import { has, get } from "lodash";

import type {
  FieldElementUnion,
  IFormSchemaV2,
} from "@graffer-inc/form-schema";
import type { ApplicantSchemaKeys, SchemaKey } from "../applicant-schema-keys";

import { APPLICANT_SCHEMA_KEYS_TEXT } from ".";

export const applicantSchemaKeysFitFormSchema = (
  formSchema: IFormSchemaV2,
  applicantSchemaKeys: ApplicantSchemaKeys,
): string[] => {
  const result: string[] = [];

  (Object.keys(applicantSchemaKeys) as (keyof ApplicantSchemaKeys)[]).forEach(
    (key) => {
      const schemaKey = applicantSchemaKeys[key];
      if (isEmptySchemaKey(schemaKey)) {
        if (key === "applicantSection" || key === "applicantType") {
          result.push(
            `${APPLICANT_SCHEMA_KEYS_TEXT.applicantSchemaKeys}のうち、「${APPLICANT_SCHEMA_KEYS_TEXT[key]}」は必ず設定してください。`,
          );
        }
        return;
      }

      if (schemaKey.formSchemaJsonPath === "") {
        result.push(
          `${APPLICANT_SCHEMA_KEYS_TEXT.applicantSchemaKeys}のうち、「${APPLICANT_SCHEMA_KEYS_TEXT[key]}」のパス情報を埋めてください。`,
        );
        return;
      }

      if (schemaKey.id === "") {
        result.push(
          `${APPLICANT_SCHEMA_KEYS_TEXT.applicantSchemaKeys}のうち、「${APPLICANT_SCHEMA_KEYS_TEXT[key]}」のIDを埋めてください。`,
        );
        return;
      }

      if (!has(formSchema, schemaKey.formSchemaJsonPath)) {
        result.push(
          `${APPLICANT_SCHEMA_KEYS_TEXT.applicantSchemaKeys}のうち、「${APPLICANT_SCHEMA_KEYS_TEXT[key]}」のパス情報を正しい値で設定してください。`,
        );
        return;
      }

      const element = get(
        formSchema,
        schemaKey.formSchemaJsonPath,
      ) as FieldElementUnion;
      if (element.id !== schemaKey.id) {
        result.push(
          `${APPLICANT_SCHEMA_KEYS_TEXT.applicantSchemaKeys}のうち、「${APPLICANT_SCHEMA_KEYS_TEXT[key]}」のパス情報とIDを正しい組み合わせで設定してください。`,
        );
        return;
      }

      return;
    },
  );

  return result;
};

const isEmptySchemaKey = (schemaKey: SchemaKey): boolean => {
  return schemaKey.formSchemaJsonPath === "" && schemaKey.id === "";
};
